import { clean } from "../format";
import type { Answer, LocalizedText, QuestionDraft, Visual } from "../types";
import type { Choice4 } from "../distractors";

export const MUL: LocalizedText = { pl: "·", en: "×" };
export const DIV: LocalizedText = { pl: ":", en: "÷" };

export function q(
  prompt: LocalizedText,
  answer: Answer,
  explanationPl: string[],
  explanationEn: string[],
  extra: { choice4?: Choice4; visual?: Visual; lessonId?: string } = {},
): QuestionDraft {
  return { prompt, answer, explanation: { pl: explanationPl, en: explanationEn }, ...extra };
}

export function numeric(value: number, unit?: LocalizedText): Answer {
  return unit ? { mode: "numeric", value: clean(value), unit } : { mode: "numeric", value: clean(value) };
}

export function fraction(num: number, den: number, acceptEquivalent = true): Answer {
  return { mode: "fraction", num, den, acceptEquivalent };
}

/** Short symbolic answer such as "XIV" or "5x+3"; `accept` lists equivalent spellings. */
export function textAnswer(value: string, accept?: string[]): Answer {
  return accept ? { mode: "text", value, accept } : { mode: "text", value };
}

/** Pick by tier. */
export function byTier<T>(tier: 1 | 2 | 3, t1: () => T, t2: () => T, t3: () => T): T {
  return tier === 1 ? t1() : tier === 2 ? t2() : t3();
}

/** Build a localized prompt from a template shared by both languages, with per-language words. */
export function both(pl: string, en: string): LocalizedText {
  return { pl, en };
}
